import { useReducer, useEffect, useMemo } from 'react';
import { isEmpty } from 'lodash';
import useApi from 'hooks/useApi';
import lookupEndpoints from './lookup-endpoints';
import { initialState, reducer } from './config';
import * as ACTIONS from './actions';

export default ({ masterObjectTypeId }) => {
  const [masterObjectAvailableOptions, dispatch] = useReducer(reducer, initialState);
  const { masterObjectTypeLookupValues } = masterObjectAvailableOptions;

  const [state, makeRequest] = useApi();
  const { data, isLoading, isError, error } = state;

  const hasMasterObjectTypeLookupValues =
    !isEmpty(masterObjectTypeLookupValues) &&
    !isEmpty(masterObjectTypeLookupValues[masterObjectTypeId]);

  const masterObjectTypeIdLookupValues =
    hasMasterObjectTypeLookupValues && masterObjectTypeLookupValues[masterObjectTypeId];

  useMemo(() => {
    // Don't send api request if the lookup values for this masterObjectTypeId have been extracted since we can use them from the reducers state
    if (hasMasterObjectTypeLookupValues) return;

    const reqParams = lookupEndpoints[masterObjectTypeId];
    makeRequest(reqParams);
  }, [hasMasterObjectTypeLookupValues, makeRequest, masterObjectTypeId]);

  useEffect(() => {
    if (isLoading) return;

    if (isError) return;

    if (data) {
      dispatch({
        type: ACTIONS.SET_MASTER_OBJECT_TYPE_ID_LOOKUP_VALUES,
        payload: { data, id: masterObjectTypeId }
      });
    }
  }, [isLoading, isError, error, data]); // eslint-disable-line react-hooks/exhaustive-deps

  return [state, masterObjectTypeIdLookupValues, dispatch];
};
